"use strict";
/**
 * QCEW & NAICS Industry Codes
 * This list leads with Quarterly Census of Employment and Wages (QCEW) codes, which are aggregate values for NAICS codes. (Leads w/ string '10')
 * This list filters out NAISC codes that have specificity greater than 4 digits.
 * Updated Mar 26, 2021
 *
 * https://www.bls.gov/cew/
 * https://www.bls.gov/cew/classifications/industry/industry-titles.htm
 */

module.exports = {
  // QCEW aggregate codes (probably what should be used for UIs)
  10: "Total, all industries",
  101: "Goods-producing",
  1011: "Natural resources and mining",
  1012: "Construction",
  1013: "Manufacturing",
  102: "Service-providing",
  1021: "Trade, transportation, and utilities",
  1022: "Information",
  1023: "Financial activities",
  1024: "Professional and business services",
  1025: "Education and health services",
  1026: "Leisure and hospitality",
  1027: "Other services",
  1028: "Public administration",
  1029: "Unclassified",
  // NAICS (filtered for only <4 digits)
  11: "Agriculture, forestry, fishing and hunting",
  111: "Crop production",
  112: "Animal production and aquaculture",
  113: "Forestry and logging",
  114: "Fishing, hunting and trapping",
  115: "Agriculture and forestry support activities",
  21: "Mining, quarrying, and oil and gas extraction",
  211: "Oil and gas extraction",
  212: "Mining, except oil and gas",
  213: "Support activities for mining",
  22: "Utilities",
  23: "Construction",
  236: "Construction of buildings",
  237: "Heavy and civil engineering construction",
  238: "Specialty trade contractors",
  "31-33": "Manufacturing",
  311: "Food manufacturing",
  312: "Beverage and tobacco product manufacturing",
  313: "Textile mills",
  314: "Textile product mills",
  315: "Apparel manufacturing",
  316: "Leather and allied product manufacturing",
  321: "Wood product manufacturing",
  322: "Paper manufacturing",
  323: "Printing and related support activities",
  324: "Petroleum and coal products manufacturing",
  325: "Chemical manufacturing",
  326: "Plastics and rubber products manufacturing",
  327: "Nonmetallic mineral product manufacturing",
  331: "Primary metal manufacturing",
  332: "Fabricated metal product manufacturing",
  333: "Machinery manufacturing",
  334: "Computer and electronic product manufacturing",
  335: "Electrical equipment and appliance mfg.",
  336: "Transportation equipment manufacturing",
  337: "Furniture and related product manufacturing",
  339: "Miscellaneous manufacturing",
  42: "Wholesale trade",
  423: "Merchant wholesalers, durable goods",
  424: "Merchant wholesalers, nondurable goods",
  425: "Electronic markets and agents and brokers",
  441: "Motor vehicle and parts dealers",
  442: "Furniture and home furnishings stores",
  443: "Electronics and appliance stores",
  444: "Building material and garden supply stores",
  445: "Food and beverage stores",
  446: "Health and personal care stores",
  447: "Gasoline stations",
  448: "Clothing and clothing accessories stores",
  451: "Sports, hobby, music instrument, book stores",
  452: "General merchandise stores",
  453: "Miscellaneous store retailers",
  454: "Nonstore retailers",
  481: "Air transportation",
  482: "Rail transportation",
  483: "Water transportation",
  484: "Truck transportation",
  485: "Transit and ground passenger transportation",
  486: "Pipeline transportation",
  487: "Scenic and sightseeing transportation",
  488: "Support activities for transportation",
  491: "Postal service",
  492: "Couriers and messengers",
  493: "Warehousing and storage",
  51: "Information",
  511: "Publishing industries, except internet",
  512: "Motion picture and sound recording industries",
  515: "Broadcasting, except internet",
  516: "516 Internet publishing and broadcasting",
  517: "Telecommunications",
  518: "Data processing, hosting and related services",
  519: "Other information services",
  52: "Finance and insurance",
  521: "Monetary authorities - central bank",
  522: "Credit intermediation and related activities",
  523: "Securities, commodity contracts, investments",
  524: "Insurance carriers and related activities",
  525: "Funds, trusts, and other financial vehicles",
  53: "Real estate and rental and leasing",
  531: "Real estate",
  532: "Rental and leasing services",
  533: "Lessors of nonfinancial intangible assets",
  54: "Professional and technical services",
  541: "Professional and technical services",
  55: "Management of companies and enterprises",
  551: "Management of companies and enterprises",
  56: "Administrative and waste services",
  561: "Administrative and support services",
  562: "Waste management and remediation services",
  61: "Educational services",
  62: "Health care and social assistance",
  621: "Ambulatory health care services",
  622: "Hospitals",
  623: "Nursing and residential care facilities",
  624: "Social assistance",
  71: "Arts, entertainment, and recreation",
  711: "Performing arts and spectator sports",
  712: "Museums, historical sites, zoos, and parks",
  713: "Amusements, gambling, and recreation",
  72: "Accommodation and food services",
  721: "Accommodation",
  722: "Food services and drinking places",
  81: "Other services, except public administration",
  811: "Repair and maintenance",
  812: "Personal and laundry services",
  813: "Membership associations and organizations",
  814: "Private households",
  92: "Public administration",
  921: "Executive, legislative and general government",
  922: "Justice, public order, and safety activities",
  923: "Administration of human resource programs",
  924: "Administration of environmental programs",
  925: "Community and housing program administration",
  926: "Administration of economic programs",
  927: "Space research and technology",
  928: "National security and international affairs",
  99: "Unclassified"
};